module.exports = __webpack_public_path__ + "static/media/blueArrowLeft.eb08f4e0.svg";